import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between gap-4" }
const _hoisted_4 = { class: "fs-6 fw-bold" }
const _hoisted_5 = { class: "d-flex gap-4" }
const _hoisted_6 = { class: "card-body" }

import { ref, onMounted } from "vue";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'RebateInfo',
  setup(__props) {

const date = ref(moment().format("YYYY-MM-DD"));
const data = ref<any>([]);
const isLoading = ref(false);
const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.checkTradeSync({ date: date.value });
    data.value = res;
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  // fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("fields.rebateInfo")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
            type: "date",
            placeholder: "Pick a day",
            style: {"width":"150px"},
            disabled: isLoading.value,
            "value-format": 'YYYY-MM-DD'
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: fetchData,
            loading: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.value,
        size: "small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "hour",
            label: _ctx.$t('fields.hour'),
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "rebateCount",
            label: _ctx.$t('fields.rebateCount'),
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "tradeCount",
            label: _ctx.$t('fields.tradeCount'),
            align: "center"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, isLoading.value]
      ])
    ])
  ]))
}
}

})